import React from 'react';
import { lazyForPaint } from 'react-loosely-lazy';
import { ff } from '@atlassian/jira-feature-flagging';
import { ScreenRedirect } from '@atlassian/jira-screen-redirect';
import type MetricDetail from '@atlassian/jira-spa-apps-admin-pages-performance-metric-detail';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page';

export const LazyMetricDetail = lazyForPaint<typeof MetricDetail>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-system-performance-metric-detail", jiraSpaEntry: "async-system-performance-metric-detail" */ '@atlassian/jira-spa-apps-admin-pages-performance-metric-detail'
		),
	),
);

// On the BE we check if the user is a premium admin or is an admin with the override FF, therefore we will just check FF enabled here
const isPerformanceAndScaleAdminPagesEnabled = () =>
	ff('override-enable-performance-and-scale-admin-menu') ||
	ff('cher-630-enable-performance-and-scale-admin-menu_4nr4c');

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () =>
	isPerformanceAndScaleAdminPagesEnabled() ? (
		<LazyPage Page={LazyMetricDetail} pageId="system-performance-metric-detail" shouldShowSpinner />
	) : (
		<ScreenRedirect to="/jira/settings/system/performance/overview" />
	);
